// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromLarge":"(min-width: 960px)","container":"G621335","content":"G80b292 G3c3c24","modalList":"G184464"};